"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamingEllipse = void 0;
var _react = _interopRequireDefault(require("react"));
var StreamingEllipse = exports.StreamingEllipse = function StreamingEllipse() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "9",
    height: "9",
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "6",
    cy: "3",
    r: "4.5",
    fill: "#28865E",
    stroke: "#282A39",
    strokeWidth: "3"
  }));
};